import { createContext, useContext, useMemo, useState } from 'react';
import { SignUpGuardSetState, SignUpGuardState } from './types';

interface Context {
  signUpGuard: SignUpGuardState;
  setSignUpGuard: SignUpGuardSetState;
}

export const SignUpGuardContext = createContext<Context | undefined>(undefined);
SignUpGuardContext.displayName = 'SignUpGuardContext';

export function SignUpGuardProvider({ children }) {
  const [signUpGuard, setSignUpGuard] = useState<SignUpGuardState>({
    open: false,
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
  const value = useMemo(() => {
    return { signUpGuard, setSignUpGuard };
  }, [signUpGuard, setSignUpGuard]);

  return (
    <SignUpGuardContext.Provider value={value}>
      {children}
    </SignUpGuardContext.Provider>
  );
}

export function useSignUpGuardContext() {
  const context = useContext(SignUpGuardContext);

  if (context === undefined) {
    throw new Error(
      `useSignUpGuardContext must be used within a SignUpGuardContext Provider`
    );
  }

  return context;
}
